import { ToastContainer } from 'react-toastify'

function AppToast(props) {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      closeOnClick
      pauseOnFocusLoss={false}
      stacked
      limit={5}
    />
  )
}

export default AppToast
